/**
 * App builders keep `search_keyword` as a sibling of `filter`. GraphQL inputs only accept it on `filter`,
 * so merge the sibling into `filter.search_keyword` immediately before the HTTP request.
 */
export const normalizeMeetingsGraphqlInputVariables = (input: unknown): unknown => {
  if (input == null || typeof input !== 'object' || Array.isArray(input)) {
    return input
  }
  const record = input as Record<string, unknown>
  if (!Object.prototype.hasOwnProperty.call(record, 'search_keyword')) {
    return input
  }
  const { search_keyword: searchKeyword, filter, ...rest } = record
  if (searchKeyword == null || searchKeyword === '') {
    return filter != null && typeof filter === 'object' && !Array.isArray(filter)
      ? { ...rest, filter }
      : { ...rest }
  }
  const prevFilter = filter != null && typeof filter === 'object' && !Array.isArray(filter)
    ? (filter as Record<string, unknown>)
    : {}
  return {
    ...rest,
    filter: {
      ...prevFilter,
      search_keyword: searchKeyword,
    },
  }
}
